// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/tarifas-flights/list',
    name: 'tarifas-flights-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/Tarifas.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'tarifas_flight',
    },
  },
]

export default formTable
